{
  "version": 1,
  "asset_id": "c7270aba-2ec8-4d7e-9a4b-c3de29db1686",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/c7270aba-2ec8-4d7e-9a4b-c3de29db1686/campsite-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/c7270aba-2ec8-4d7e-9a4b-c3de29db1686/campsite-thumb.webp",
  "original_filename": "campsite-thumb.webp",
  "size": 3972,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:25Z"
}
